import React from 'react';
import { observer } from 'mobx-react';
import { CaseFillInTheBlanksCardWrapper } from '@seedlang/hoc';
import styled from '@emotion/styled';
import MediaSection from 'components/vocab_card/media_section';
import CardSection from 'components/vocab_card/card_section';
import { DeckUI } from '@seedlang/state';
import CardWrapper from 'components/layout/card_wrapper';
import CardContent from 'components/layout/card_content';
import Text from 'components/text';
import SentenceBreakdown from 'components/sentence_breakdown';
import TextResizer from 'components/text_resizer';
import Spinner from 'components/spinner';
import { flexCenterColumn } from '@seedlang/style_mixins';
import { Theme, Constants } from '@seedlang/constants';
import EvaluateButtons from 'components/card/evaluate_buttons';
import MultipleChoiceButtons from 'components/card/multiple_choice_buttons';

const SentenceWrapper = styled.div`
  ${flexCenterColumn()}
  flex: 1;
  width: 100%;
  height: 80%;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: ${Theme.z['card-4']};
  .fa-check {
    color: ${Theme.green};
  }
  .fa-times {
    color: ${Theme.red};
  }
`;

@observer
class CaseFillInTheBlanksCardMultipleChoice extends React.Component {
  render() {
    return (
      <CardWrapper
        card={this.props.card}
        cardState={this.props.cardState}
        userCard={this.props.userCard}
        icons={this.props.icons}
      >
        <CardContent
          height={this.props.cardState.revealed ?
            DeckUI.layout.contentHeight :
            DeckUI.layout.contentHeightWithMultipleChoiceButtons(this.props.wordFormOptions?.length || 4)
          }
        >
          {
            this.props.cardState.revealed &&
              <MediaSection
                showMedia
                autoPlay={this.props.inView}
                card={this.props.card}
                cardState={this.props.cardState}
                height={this.props.sectionHeight}
                borderTopRadius={10}
              />
          }
          <CardSection
            background='#FFF'
            padding='20px'
            numSections={this.props.numSections}
            borderTopRadius={this.props.cardState.revealed ? 0 : 10}
            height={this.props.sectionHeight}
          >
            <TextResizer
              resizeText
              height={this.props.sectionHeight - 20}
              width={DeckUI.layout.innerDeckWidth - 40}
              characterLength={this.props.topSectionText && this.props.topSectionText.length}
            >
              <Text
                rtl={Constants.RTL_LANGUAGE_IDS.includes(this.props.topSectionLanguageId)}
              >
                {this.props.topSectionText}
              </Text>
            </TextResizer>
          </CardSection>
          <CardSection
            numSections={this.props.numSections}
            padding='20px'
            background='#f5f5f5'
            borderBottomRadius={10}
            height={this.props.sectionHeight}
          >
            {
              this.props.cardState.revealed &&
                <IconWrapper>
                  {
                    this.props.userCard.correct &&
                      <i className='fa fa-check' />
                  }
                  {
                    !this.props.userCard.correct &&
                      <i className='fa fa-times' />
                  }
                </IconWrapper>
            }
            <SentenceWrapper>
              {
                this.props.customPrompt && !this.props.cardState.revealed &&
                  <Text
                    italic
                    fontSize='14px'
                    color='#565656'
                    textAlign='center'
                  >
                    {this.props.customPrompt}
                  </Text>
              }
              <TextResizer
                resizeText
                maximumFontSize={30}
                height={this.props.cardState.revealed ? this.props.sectionHeight - 80 : this.props.sectionHeight - 20}
                width={DeckUI.layout.deckWidth - 40}
                characterLength={this.props.card.sentence && this.props.card.sentence.targetText && this.props.card.sentence.targetText.length}
              >
                <SentenceBreakdown
                  center
                  hideTextInput={!this.props.cardState.revealed}
                  showUnderline={this.props.cardState.revealed}
                  showCase={this.props.cardState.revealed}
                  inputWordAssociationIds={this.props.cardState.revealed ? [] : this.props.card.wordAssociationIds}
                  highlightWordAssociationIds={this.props.cardState.revealed ? this.props.card.wordAssociationIds : []}
                  highlightType='background'
                  sentence={this.props.card.sentence}
                  disableOnClick={!this.props.cardState.revealed}
                />
              </TextResizer>
              {
                this.props.card.sentence && !this.props.card.sentence.enrichedWords &&
                  <Spinner
                    width='40px'
                    height='12px'
                    margin='10px auto 0'
                    background='#999'
                  />
              }
            </SentenceWrapper>
            {
              this.props.cardState.revealed &&
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  <Text bold color={this.props.userCard.correct ? Theme.green : Theme.red}>
                    {this.props.userCard.correct ? this.props.correctMessage : this.props.incorrectMessage}
                  </Text>
                </div>
            }
          </CardSection>
        </CardContent>
        {
          !this.props.cardState.revealed &&
            <MultipleChoiceButtons
              options={this.props.wordFormOptions}
              selected={this.props.selectedWordForm ? [this.props.selectedWordForm] : []}
              onClick={this.props.onSelectWordForm}
              disabled={this.props.cardState.revealed}
              field='label'
              languageId='DE'
              revealed={this.props.cardState.revealed}
              correct={this.props.userCard.correct}
              width={DeckUI.layout.innerDeckWidth}
              height={DeckUI.layout.totalMultipleChoiceButtonHeight(this.props.wordFormOptions?.length || 4)}
              buttonHeight={DeckUI.layout.multipleChoiceButtonHeight}
              fontSize='16px'
              isMobile={DeckUI.layout.isMobile}
            />
        }
        {
          this.props.cardState.revealed &&
            <EvaluateButtons
              card={this.props.card}
              cardState={this.props.cardState}
              userCard={this.props.userCard}
              disabled={!this.props.inView}
              onNextClick={this.props.onNextClick}
              onCheckAnswer={this.props.onCheckAnswer}
            />
        }
      </CardWrapper>
    );
  }
}

export default CaseFillInTheBlanksCardWrapper(CaseFillInTheBlanksCardMultipleChoice);